import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {makeMapStateToProps} from '../../../../helpers/reselectHelpers';
import {DraftMessageModel} from '../../../../models/api/messageModel';
import {AppState} from '../../../../store/appState';
import {getConversations} from '../../../../store/data/dataSelectors';
import {makeGetDraftChannel} from '../../../../store/data/messages/messagesSelectors';
import {getIsUserVisitor} from '../../../../store/data/teammates/teammatesSelectors';
import {makeGetIsPersonalizedDemoInboxActive} from '../../../../store/stateless/guidedDemoSelectors';
import {ComposerChannelPicker} from './composerChannelPicker';
import {ChannelSaver} from './pickChannelDropdownContainer';

/*
 * Props.
 */

interface ComposerChannelPickerContainerProps {
  message: DraftMessageModel;
  saveChannel: ChannelSaver;
}

/*
 * Selectors.
 */

function getMessage(_state: AppState, props: ComposerChannelPickerContainerProps) {
  return props.message;
}

function getConversationId(_state: AppState, props: ComposerChannelPickerContainerProps) {
  return props.message.conversationId;
}

const getConversation = createSelector(
  [getConversationId, getConversations],
  (conversationId, conversations) => {
    const conversation = conversations[conversationId];
    if (!conversation) {
      return undefined;
    }

    return conversation;
  },
);

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<ComposerChannelPickerContainerProps>()(() => ({
  isUserVisitor: getIsUserVisitor,
  channel: makeGetDraftChannel(getMessage),
  isPersonalizedDemoInboxActive: makeGetIsPersonalizedDemoInboxActive(getConversation),
}));

export const ComposerChannelPickerContainer = connect(mapStateToProps)(ComposerChannelPicker);
